import { KEY_SEPARATOR } from 'shared/consts/translations';

export function translationKey(...parts: string[]): string {
  return parts.join(KEY_SEPARATOR);
}
